import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';

import TopbarSearch from '../../TopbarSearch';

const TopbarMobileBottom = ({ gaEventCategory, isTopScrollPosition }) => (
  <Box
    className={twJoin(
      'absolute w-full flex-row items-center justify-between rounded-none p-4 shadow-[0px_4px_10px_0px_rgba(87,87,87,0.2)] transition-all duration-300 ease-in dark:border-b dark:border-neutral-low-300 lg:hidden',
      isTopScrollPosition ? 'top-[73px]' : 'top-0'
    )}
  >
    <TopbarSearch gaEventCategory={gaEventCategory} />
  </Box>
);

export default TopbarMobileBottom;
